import React, { Fragment, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { isEmpty, keys } from 'lodash-es';

import TrendingAppsTable from '../components/TrendingAppsTable';
import Header from '../../shared/components/Header';
import RelatedAppStoreAnalitics from '../../shared/components/RelatedAppStoreAnalitics';
import TopChartsFilters from '../../shared/components/TopChartsFilters';
import LoadingOverlay from '../../../../../components/LoadingOverlay';
import { initParams, parseUrlForFilters } from '../configs';
import helpers from '../../../../../utils/helpers';

// Static configs
const { availableCategories, shareOptions, data } = initParams();

const enableTopFilters = ['store', 'categories', 'countries'];

const PageContainer = () => {
  useEffect(() => {
    const onPopstate = () => window.location.reload();
    window.addEventListener('popstate', onPopstate);
    return () => window.removeEventListener('popstate', onPopstate);
  }, []);

  const baseUrl = ({ store, category, country }) =>
    `${window.location.origin}/top-charts/trending-apps/${store}/${category}/${country}`;

  const p = parseUrlForFilters();

  const handleFilterChange = useCallback((filter) => {
    const defaultParsedURL = !filter.store && keys(p).length === 1 && p.store === undefined;
    const defaultStore =
      (filter.store && (filter.store === 'itunes-connect' || filter.store === 'itunes_connect')) ||
      defaultParsedURL ||
      (!filter.store && p.store === 'itunes-connect');
    const defaultFilters = {
      category: defaultStore ? 'top-overall' : 'overall',
      country: 'united-states',
      store: defaultStore ? 'itunes-connect' : 'google-play',
    };
    const countrySlug = filter.country && helpers.convertToSlug(COUNTRIES_ARRAY[filter.country]);
    const categorySlug = availableCategories[filter.category];
    const allFilters = {
      store: filter.store || defaultParsedURL ? defaultFilters.store : p.store,
      category:
        categorySlug ||
        (filter.store && defaultFilters.category) ||
        p.category ||
        defaultFilters.category,
      country: countrySlug || p.country || defaultFilters.country,
    };
    window.location.assign(`${baseUrl(allFilters)}`);
  }, []);

  const childComponent = <RelatedAppStoreAnalitics store={data.store} type="Apps" />;
  const renderPortal = () =>
    ReactDOM.createPortal(
      childComponent,
      document.getElementById('related-trending-apps-analytics')
    );

  const headline = (
    <span>
      Best <span className="text-blue">{data.default_os_name}</span> Mobile Apps Trends
    </span>
  );

  const subheadline = `Top list of the most trending free, paid and grossing apps for ${data.category_name} in ${data.country_name}`;

  return (
    <Fragment>
      <LoadingOverlay loading={isEmpty(data)} />
      <Fragment>
        <Header headline={headline} subheadline={subheadline} />
        <section className="container">
          <TopChartsFilters
            filters={data}
            onFilterChange={handleFilterChange}
            enableTopFilters={enableTopFilters}
            shareOptions={shareOptions}
          />
          <TrendingAppsTable />
        </section>
      </Fragment>
      {renderPortal()}
    </Fragment>
  );
};

export default PageContainer;
